import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const InterimRedirect: React.FC = () => {
    const history = useHistory();

    useEffect(() => {
        history.push(`/digital-advice/interim-recommend/question`);
    }, []);

    return <React.Fragment></React.Fragment>;
};

export default InterimRedirect;
